import React, { useState } from 'react';
import { BellRing, X } from 'lucide-react';

const DISMISS_KEY = 'portal_notif_prompt_dismissed';

export const NotifyPrompt = ({ onEnable }) => {
  const supported = typeof window !== 'undefined' && 'Notification' in window && 'serviceWorker' in navigator;
  const [state, setState] = useState(supported ? Notification.permission : 'unsupported');
  const [hidden, setHidden] = useState(localStorage.getItem(DISMISS_KEY) === '1');
  if (!supported || state !== 'default' || hidden) return null;

  const enable = async () => {
    await onEnable();
    setState(Notification.permission);
  };
  return (
    <div className="mx-4 mt-3 flex items-center gap-3 rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-2.5" data-testid="portal-notify-prompt">
      <BellRing className="h-5 w-5 flex-shrink-0 text-indigo-600" />
      <p className="flex-1 text-xs text-indigo-900">Get alerts with sound for leave approvals, payslips and HR messages, even when the portal is closed.</p>
      <button onClick={enable} className="rounded-lg bg-indigo-600 px-3 py-1.5 text-xs font-semibold text-white" data-testid="portal-notify-enable">Turn on</button>
      <button onClick={() => { localStorage.setItem(DISMISS_KEY, '1'); setHidden(true); }} className="text-indigo-400" data-testid="portal-notify-dismiss"><X className="h-4 w-4" /></button>
    </div>
  );
};
